<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Tạo kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataWarehouse.warehouse_name.label"
                                        :id="dataWarehouse.warehouse_name.id"
                                        :placeholder="dataWarehouse.warehouse_name.placeholder"
                                        :value-default="dataWarehouse.warehouse_name.value"
                                        @inputValue="onChange($event, dataWarehouse.warehouse_name.id)"
                                        :error-text="dataWarehouse.warehouse_name.error"
                                        :is-error="dataWarehouse.warehouse_name.isError"
                                        @blur="validateForm($event, dataWarehouse.warehouse_name.id)"
                                        :required="dataWarehouse.warehouse_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataWarehouse.warehouse_code.label"
                                        :id="dataWarehouse.warehouse_code.id"
                                        :placeholder="dataWarehouse.warehouse_code.placeholder"
                                        :value-default="dataWarehouse.warehouse_code.value"
                                        @inputValue="onChange($event, dataWarehouse.warehouse_code.id)"
                                        :error-text="dataWarehouse.warehouse_code.error"
                                        :is-error="dataWarehouse.warehouse_code.isError"
                                        @blur="validateForm($event, dataWarehouse.warehouse_code.id)"
                                        :required="dataWarehouse.warehouse_code.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataWarehouse.warehouse_phone.label"
                                        :id="dataWarehouse.warehouse_phone.id"
                                        :placeholder="dataWarehouse.warehouse_phone.placeholder"
                                        :value-default="dataWarehouse.warehouse_phone.value"
                                        @inputValue="onChange($event, dataWarehouse.warehouse_phone.id)"
                                        :error-text="dataWarehouse.warehouse_phone.error"
                                        :is-error="dataWarehouse.warehouse_phone.isError"
                                        @blur="validateForm($event, dataWarehouse.warehouse_phone.id)"
                                        :required="dataWarehouse.warehouse_phone.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataWarehouse.warehouse_address.label"
                                        :id="dataWarehouse.warehouse_address.id"
                                        :placeholder="dataWarehouse.warehouse_address.placeholder"
                                        :value-default="dataWarehouse.warehouse_address.value"
                                        @inputValue="onChange($event, dataWarehouse.warehouse_address.id)"
                                        :error-text="dataWarehouse.warehouse_address.error"
                                        :is-error="dataWarehouse.warehouse_address.isError"
                                        @blur="validateForm($event, dataWarehouse.warehouse_address.id)"
                                        :required="dataWarehouse.warehouse_address.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createOrUpdateWarehouse"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
